import React, { useEffect } from 'react';
import { DateField } from 'react-admin';
import {
    Datagrid,
    TextField,
    ShowButton,
    ReferenceManyField,
} from 'react-admin';
import { ReferenceField } from 'react-admin';

export const InvoicesCommunicationsList = props => {
    useEffect(() => {
        localStorage.setItem(
            'currentComMod',
            `/invoices/${props.record.id}/show/3`
        );
    }, []);
    return (
        <ReferenceManyField
            reference="Communication-records"
            target="resourceId"
            filter={{ resourceId: props.record.id, resourceType: 'invoice' }}
            {...props}
        >
            <Datagrid>
                <TextField source="serial" sortable={false} />
                <TextField source="id" label="Communication Id" />
                <TextField source="taskStatus" label="Task Status" />
                <TextField source="taskType" label="Task Type" />
                <TextField source="templateName" label="Template Name" />
                <TextField source="senderEmail" label="Sender Email" />
                <TextField source="recipientEmail" label="Recipient Email" />
                <TextField source="channel" label="Channel" />
                <TextField source="deliveryStatus" label="Delivery Status" />
                {/* <DateField source="sendDate" label="Send Date" /> */}
                <DateField
                    locales="en-IN"
                    source="sendDate"
                    label="Send Date"
                    showTime
                />

                <ShowButton />
            </Datagrid>
        </ReferenceManyField>
    );
};
